import { render } from "./rekananMampu.vue?vue&type=template&id=ca84cc90"
import script from "./rekananMampu.vue?vue&type=script&lang=js"
export * from "./rekananMampu.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__